import { toggleBuilding, isBuildingSaved } from 'client/javascript/saved_buildings_cookie';
import { trackSavingBuildingEvent } from 'client/shared/saving_analytics';

export const SAVE_BUTTON_ICON = '.heart';

export function initializeSaveButtons(cardClass) {
  const cards = document.querySelectorAll(cardClass);
  cards.forEach(card => {
    const isSaved = isBuildingSaved(card.dataset.buildingId);

    if (isSaved) {
      const emptyHeart = card.querySelector('.empty-heart-icon-circle');
      const filledHeart = card.querySelector('.filled-heart-icon-circle');

      emptyHeart.classList.add('hidden');
      filledHeart.classList.remove('hidden');
    }
  });
}

function toggleHeartFill(heartToHide, heartToShow) {
  heartToHide.classList.add('hidden');
  heartToShow.classList.remove('hidden');
}

export function setupSaveListener(containerClass, saveButtonIconClass = SAVE_BUTTON_ICON) {
  const container = document.querySelector(containerClass);
  container.addEventListener('click', event => {
    const closestHeart = event.target.closest(saveButtonIconClass);
    if (closestHeart) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const buildingCard = closestHeart.parentElement;
      const emptyHeart = buildingCard.querySelector('.empty-heart-icon-circle');
      const filledHeart = buildingCard.querySelector('.filled-heart-icon-circle');
      let isUnsavedToSaved;
      if (event.target.closest('.empty-heart-icon-circle')) {
        isUnsavedToSaved = true;
        toggleHeartFill(emptyHeart, filledHeart);
      } else {
        isUnsavedToSaved = false;
        toggleHeartFill(filledHeart, emptyHeart);
      }
      const { buildingId } = buildingCard.dataset;
      toggleBuilding(buildingId);

      // Send Analytics event
      trackSavingBuildingEvent(isUnsavedToSaved, buildingId, containerClass);
    }
  });
}
